import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidationErrors, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppDataService } from 'src/app/services/data/app-data.service';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { LoaderService } from '../services/loader/loader.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-password-forgotten',
    templateUrl: './password-forgotten.component.html',
    styleUrls: ['./password-forgotten.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink, FaIconComponent, FormsModule, ReactiveFormsModule, TranslateModule]
})
export class PasswordForgottenComponent implements OnInit {
  faArrowLeft = faArrowLeft;

  form: FormGroup;

  constructor(
    private authService: AuthService,
    private appDataService: AppDataService,
    private loaderService: LoaderService,
    private translateService: TranslateService
  ) {}

  get email(): FormControl {
    return this.form.get('email') as FormControl;
  }

  ngOnInit() {
    this.form = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email])
    });
  }

  submitForm(): void {
    this.form.markAsTouched();

    if (this.form.valid) {
      this.form.disable();

      this.loaderService.presentLoader();

      this.authService.resetPassword(this.form.value.email)
        .then(async () => {
          await this.loaderService.hideLoaderOnSuccess(
            this.translateService.instant('USERS.RESET_EMAIL_SENT')
          );
          this.form.enable();
          this.form.reset();
        })
        .catch(async err => {
          console.log(err);
          this.form.enable();

          await this.loaderService.hideLoaderOnFailure(err.message);
        });
    }
  }
}
